import { useEffect } from "react";
import "./style/portfolio.css";
import {AiFillGithub} from "react-icons/ai";
import { useState } from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Portfolio = () => {
    const [repos, setRepos] = useState([]);
    const [Images, setImg] = useState([]);

    useEffect(() => {
      fetch("https://api.github.com/users/mounaimMoussaoui/repos")
      .then((res) => {
          return res.json();
      })
      .then(data => setRepos(data));

      fetch("https://api.unsplash.com/search/photos?page=1&query=office&client_id=i5oNeAhyHAsBAvidLTV2LUtFJf85p9_CfE-d2MHo_yw")
      .then((res) => {
        return res.json();

      })
      .then((data) =>{ 
        setImg(data.results)
      });

    }, []);

    // const listImgs = ["myPortfolio/project8.png", "myPortfolio/project2.jpg","myPortfolio/project3.png", "myPortfolio/project4.png", "myPortfolio/project5.png", "myPortfolio/project6.png", "myPortfolio/todoPrj.jpg", "myPortfolio/pc.jpg"]
    return (
      <div className="flex flex-col gap-[30px] p-4 w-full text-center overflow-hidden">
        <h1 className="text-[40px] font-bold my-[30px] head-section" data-text="Portfolio">Portfolio</h1>
        <iframe name="iframe" src="https://mounaimmoussaoui.github.io/RockPaperScissorsGame/" className="w-full min-h-[80vh] shadow-lg rounded-lg frame" title="This frame come a small tab to show all works"></iframe>
          <h1 className="my-4 text-[40px] font-[700] text-head mx-auto">All Works</h1>
        <div className="container w-full">
          {
            repos.filter(repo => !repo.fork).map((repo) => {
              return (
                <div key={repo.id} className="proj shadow h-[200px] rounded-lg relative flex items-center overflow-hidden justify-center">
                <a href={`https://mounaimmoussaoui.github.io/${repo.name}/index.html`} title="Path the Live Demo" target={"iframe"}>
                    <LazyLoadImage src={Images[Math.trunc(Images.length * Math.random())].urls.regular} alt="prj-img" width={"100%"} height={"100%"} effect="blur" className="w-full h-full bg-[#ccc]" onClick={() => window.scroll({top: 0, behavior: "smooth"})}/>
                  </a>
                  <a href={repo.html_url} title="Path The Repository" className="btn-git absolute w-[40px] h-[40px] flex items-center justify-center bg-[#fff] hover:bg-[#ffffff99] right-2 top-2 rounded-[50%] transition-[0.3s]">
                      <AiFillGithub className="w-[25px] h-[25px]"/>
                      <span className="txtTol absolute right-[110%] w-[max-content] px-2 text-sm text-[#555] rounded-sm bg-[#ffffff99]">see the code in the github</span>
                  </a>
                  <div className="content-proj transition-[0.5s] absolute bottom-[-20%] opacity-0 w-full p-4 text-start text-black-50">
                    <span className="text-[20px] font-bold">{repo.name}</span>
                    <p className="text-sm font-[600]">{repo.description}</p>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    );
  };
  
  export default Portfolio;
